import { render, staticRenderFns } from "./plant.vue?vue&type=template&id=fbd628ae"
import script from "./plant.vue?vue&type=script&lang=js"
export * from "./plant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports